import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header, Footer } from './index';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Hide header/footer for quiz-taking pages (not quiz results pages)
  const isRegularQuizPage = location.pathname.match(/^\/quiz\/[^/]+$/) !== null;
  const isWiziQuizAttemptPage = location.pathname.match(/^\/mock-test\/attempt\/\d+$/) !== null;
  const shouldHideHeaderFooter = isRegularQuizPage || isWiziQuizAttemptPage;
  
  // Hide only footer for study plan wizard
  const shouldHideFooter = shouldHideHeaderFooter || location.pathname === '/study-plan';
  
  return (
    <>
      {!shouldHideHeaderFooter && <Header />}
      {children}
      {!shouldHideFooter && <Footer />}
    </>
  );
};

export default Layout;
